import { getAppData } from '@lib/appInitialState';
import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import DefaultTemplate from '@components/templates/DefaultTemplate';
import PageInsetTop from '@components/atoms/PageInsetTop';
import { Box, Container, Typography } from '@mui/material';

export default function NotFound() {
  const { t, i18n } = useTranslation();

  return (
    <>
      <Head>
        <title>
          {t('pages.vehiclefleetapp.not-found.metaTitle')}
        </title>
        <meta
          content={t('pages.vehiclefleetapp.not-found.metaDescription')}
          name="description"
        />
        <meta content={t('pages.vehiclefleetapp.not-found.metaTitle')} property="og:title" />
      </Head>
      <DefaultTemplate>
        <Container>
          <PageInsetTop />
          <Box>
            <Typography component="h1" gutterBottom variant="h1">
              {t('pages.vehiclefleetapp.not-found.metaTitle')}
            </Typography>
            <Typography variant="body2">
              {t('pages.vehiclefleetapp.not-found.metaDescription')}
            </Typography>
          </Box>
        </Container>
      </DefaultTemplate>
    </>
  );
}

export async function getServerSideProps(ctx) {
  const {
    query,
    res,
    locale,
  } = ctx;
  const [graphQlClient, appData] = await getAppData(ctx);

  if (res) {
    res.setHeader('Cache-Control', 'public, max-age=3600');
  }

  return {
    props: {
      ...appData,
    },
  };
}
